import Vue from "vue";
import OrderList from "./order/orderList"
import NoOpTable from "./log/table"

let componentMap = [
    OrderList,NoOpTable
]
componentMap.forEach((item) => {
    Vue.component(item.name, item)
})